import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';

const setUncubesControllerReady = (state) => {
  state.uncubesServerReady = true;
};

const storeKPI = (state, model) => {
  state.kpiStorage.push(model);
};

const updateKPI = (state, model) => {
  const existingModelIndex = state.kpiStorage.findIndex((el) => el.kpiType === model.kpiType
    && el.isManaged === model.isManaged
    && el.pointOfSaleGuid === model.pointOfSaleGuid);
  if (existingModelIndex !== -1) {
    state.kpiStorage.splice(existingModelIndex, 1, model);
  }
};

const resetPointOfSaleState = (state) => {
  state.uncubesServerReady = false;
  state.kpiStorage = [];
};

export const mutations = {
  [MutationTypes.SET_UNCUBES_SERVER_READY]: setUncubesControllerReady,
  [MutationTypes.STORE_KPI]: storeKPI,
  [MutationTypes.UPDATE_KPI]: updateKPI,
  [RESET_POINT_OF_SALE_STATE]: resetPointOfSaleState,
};
